import React, { Fragment } from 'react';
const idSet = new Set();
function errorOnce(key, message) {
    if (idSet.has(key)) {
        return;
    }
    idSet.add(key);
    console.error(message);
}
function debugOnce(key, message) {
    if (idSet.has(key)) {
        return;
    }
    idSet.add(key);
    // eslint-disable-next-line no-console
    console.debug(message);
}
export const Unknown = function Unknown(props) {
    if (process.env.NODE_ENV === 'production') {
        debugOnce(props.id, `Unable to resolve component with id ${props.id}`);
        return React.createElement(Fragment, null);
    }
    errorOnce(props.id, `Unable to resolve component with id ${props.id}`);
    return React.createElement(Fragment, null, "UNKNOWN!!!");
};
